import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { PagesModule } from '@pages/pages.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { JwtInterceptor } from '@core/interceptors/jwt.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faArrowLeft as fasArrowLeft,
  faBars as fasBars,
  faCheck as fasCheck,
  faComment as fasComment,
  faHome as fasHome,
  faInfoCircle as fasInfoCircle,
  faQuestionCircle as fasQuestionCircle,
  faSignInAlt as fasSignInAlt,
  faSignOutAlt as fasSignOutAlt,
  faTimes as fasTimes,
} from '@fortawesome/free-solid-svg-icons';
import { faClone as farClone, faFilePdf as farFilePdf } from '@fortawesome/free-regular-svg-icons';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '@environment/environment';
import { FeatureFlagsService } from '@core/services/feature-flags.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__Zone_enable_cross_context_check = true;

const oktaAuth = new OktaAuth({
  issuer: `${environment.services.okta.url}/oauth2/default`,
  redirectUri: `${window.location.origin}/auth/callback`,
  postLogoutRedirectUri: `${window.location.origin}/session-expired`,
  clientId: environment.services.okta.clientId,
  pkce: true,
  scopes: ['openid', 'email', 'groups', 'okta.myAccount.profile.read', 'okta.myAccount.profile.manage'],
  tokenManager: {
    storage: 'cookie',
  },
});


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    OktaAuthModule.forRoot({ oktaAuth }),
    HttpClientModule,
    CoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    FontAwesomeModule,
    PagesModule,
    NgbModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (featureFlags: FeatureFlagsService) =>
        () => new Promise((resolve) => featureFlags.populate().subscribe({ next: () => resolve(true) })),
      deps: [FeatureFlagsService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private library: FaIconLibrary) {
    library.addIcons(
      fasBars,
      fasTimes,
      fasHome,
      fasArrowLeft,
      fasInfoCircle,
      fasCheck,
      farClone,
      farFilePdf,
      fasSignOutAlt,
      fasSignInAlt,
      fasQuestionCircle,
      fasComment,
    );
  }
}
